import {
  Box, CardProps, Flex, Heading, Skeleton,
} from "@chakra-ui/react";
import { PropsWithChildren } from "react";

interface IntegrationSectionProps extends PropsWithChildren, CardProps {
  title: string;
  isLoaded: boolean;
}

export default function IntegrationSection({
  isLoaded,
  title,
  children,
  ...rest
}: IntegrationSectionProps) {
  return (
    <Skeleton isLoaded={isLoaded}>
      <Box mb="4">
        <Heading as="h2" fontSize="lg" color="fg.muted">
          {title}
        </Heading>
      </Box>
      <Flex justifyContent="start" width="100%" h="100%" mb="12">
        {children}
      </Flex>
    </Skeleton>
  );
}
